export default function Login() {
  const params = new URLSearchParams(window.location.search);
  const error = params.get('error');
  return (
    <div className="login-page">
      <div className="login-card">
        <img className="login-banner" src="/soupos-banner.png" alt="SoupOS" />
        <img className="login-icon" src="/soupos-icon.png" alt="" />
        <h1>SoupOS</h1>
        <p>Custom Discord utility bot for dum4hub</p>
        {error && <p style={{ color: 'var(--danger)' }}>Login failed: {error}</p>}
        <a className="btn" href="/auth/login">Log in with Discord</a>
        <p className="dim" style={{ marginTop: '2rem', fontSize: 12 }}>
          You need Manage Server permission on at least one server where SoupOS is installed.
        </p>
      </div>
    </div>
  );
}
